import { useParams } from "react-router-dom";
import { useAdminUser } from "features/admin";
import { useAuth } from "features/auth";
import { EntityNotFound } from "features/layouts";
import { Head } from "features/misc";
import { Profile } from "features/profile";
import { useAdminRewards } from "features/admin/api/useAdminUser";
import { LoadingSpinner } from "atoms";

function AdminUserDetails() {
  const { user } = useAuth();
  const { userId } = useParams() as { userId: string };
  const query = useAdminUser(userId);
  const { data: rewards } = useAdminRewards(userId);

  const isSuperAdmin = !!user?.roles.find((r) => r === "superAdmin");
  const isAdmin = isSuperAdmin || !!user?.roles.find((r) => r === "admin");

  const is404Error = query.isError && query.error.status === 404;
  const isOtherError = query.isError && query.error.status !== 404;

  return (
    <>
      <Head title={`${query.data?.name} | Admin`} />

      {is404Error && (
        <EntityNotFound
          type="user"
          linkText="User Search"
          linkTo="/admin/users"
        />
      )}
      {isOtherError && <em>Error Loading User</em>}

      {query.isLoading && <LoadingSpinner />}

      {query.isSuccess && (
        <Profile
          user={query.data}
          isAdmin={isAdmin}
          isSuperAdmin={isSuperAdmin}
          rewards={rewards}
        />
      )}
    </>
  );
}

export { AdminUserDetails };
